// import { useEffect } from "react";
// import BottomNav from "./BottomNav";
// import Navbar from "./MainCmp/Navbar";
import SupportBox from "./SupportBox";
import SupportImg from "../../assets/support.png";
import Footer from "../../Components/Core/InfoFooter";
import SeoHead from "../../Components/Core/SeoHead";
import { useTenantContent } from "../../Context/TenantContentContext";
import { joinUrl } from "../../utils/seo";

const Support = () => {
  const { content } = useTenantContent();
  const siteName = content?.siteName || "سایت پزشک";

  return (
    <>
      <SeoHead
        title={`پشتیبانی | ${siteName}`}
        description={`راه‌های ارتباط با پشتیبانی ${siteName}.`}
        keywords={content?.siteKeywords}
        canonical={joinUrl(content?.canonicalUrl, "support")}
        image={content?.ogImage}
        imageAlt={siteName}
        siteName={siteName}
      />
      {/* <Navbar /> */}
      <div
        className="iran-sans"
        style={{
          minHeight: "100vh",
        }}
      >
        <div>
          <h1 className="text-end pe-3 mt-5 me-lg-5 fw-bold color-blue highlight-box highlight-secondary me-2 me-sm-0">
            پشتیبانی
          </h1>
        </div>
        <div className="mt-4 d-flex justify-content-center">
          <img
            src={SupportImg}
            alt="پشتیبانی"
            style={{
              width: "100%",
              maxWidth: "220px",
              height: "auto",
            }}
          />
        </div>
        <div className="container">
          <div className="row mt-5">
            <div className="col-12">
              <p className="text-end pe-3 me-lg-5 me-md-3 fs-5 fw-semibold color-blue">
                از راه های زیر می توانید با ما در ارتباط باشید
              </p>
            </div>
          </div>

          <SupportBox />

          <div className="row mt-4 mt-md-5 justify-content-center">
            <div className="col-5 col-md-4 col-lg-3 col-xl-2">
              <hr />
            </div>
          </div>
        </div>
      </div>
      {/* <BottomNav /> */}
      <Footer />
    </>
  );
};

export default Support;
